import styled from 'styled-components'

export const SubmissionCardModalApproveCostBreakdownSpacer = styled.div`
  height: 7.75rem;
`
